module.exports = __webpack_public_path__ + "static/reactdaytalk-1001f61f681fd27e4de8681f86640787.jpeg";